function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Attachment({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.135 23.076c-1.834 0-3.667-.7-5.06-2.1-2.776-2.79-2.765-7.317.025-10.093l8.343-8.303a5.442 5.442 0 017.686.018 5.442 5.442 0 01-.02 7.687l-7.661 7.623a3.735 3.735 0 01-5.274-.013 3.735 3.735 0 01.012-5.274l5.22-5.196a1 1 0 111.412 1.419l-5.221 5.195a1.732 1.732 0 00-.005 2.446 1.732 1.732 0 002.446.006l7.66-7.624a3.41 3.41 0 001.013-2.427 3.41 3.41 0 00-1-2.43 3.44 3.44 0 00-4.857-.012L5.51 12.3a5.144 5.144 0 00-.018 7.267 5.145 5.145 0 007.266.017l5.932-5.903a1 1 0 011.41 1.418L14.17 21a7.116 7.116 0 01-5.035 2.075",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoAttachment = React.memo(Attachment);
export default MemoAttachment;